import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import {
  ApiClientService,
  ApiResponse
} from './../../shared/services/api-client.service';
import { AB_API_GET_CREDITCARDS } from './../../shared/constants';
import { IBalance } from '../../shared/interfaces/balance.interface';

enum ICreditCardStatus {
  ACTIVE = 'Active',
  UNLINKED = 'Unlinked',
  BLOCKED = 'Blocked'
}

interface ICard {
  id: string;
  number: string;
  name: string;
  limit: IBalance;
  balance: IBalance;
  availableCredit: IBalance;
  status: ICreditCardStatus;
  suffix: string;
  cardType: string;
  pendingLimitRequest: boolean;
}

interface CreditCardsResponse extends ApiResponse {
  cards: Array<ICard>;
}

@Injectable({
  providedIn: 'root'
})
export class CreditCardsService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AB_API_GET_CREDITCARDS);
  }

  getCreditCards(): Observable<CreditCardsResponse> {
    return this.get();
  }

  unlinkCreditCard(suffix: string) {
    return this.delete({
      suffix: suffix
    });
  }
}

export { CreditCardsResponse, ICard, ICreditCardStatus };
